import React ,{ useState }from "react";
//import axios from "axios";
//import CodeExample from "../../partials/content/CodeExample";
//import { Table } from "react-bootstrap";
import { Bounce } from 'react-activity';
import 'react-activity/dist/react-activity.css';

import { getSchedules,getNotes,completeTask,getScreenFields,updateNoti,getSettings,getMaster,getStatus,getPatientRights,getAccounts ,getSchedulesExport} from "../../crud/auth.crud";
import { Link } from "react-router-dom";
import { IconButton,TextField,MenuItem,InputLabel,Select } from '@material-ui/core';
import { Tooltip } from "@material-ui/core";	
//import InfiniteScroll from "react-infinite-scroller";
import SearchIcon from '@material-ui/icons/Search';
import DateFnsUtils from '@date-io/date-fns';
import {  format } from 'date-fns'
import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import Grid from '@material-ui/core/Grid';					
import EditIcon from '@material-ui/icons/Edit';		
import DescriptionIcon from '@material-ui/icons/Description';			
																	

import Button from '@material-ui/core/Button';
import SaveIcon from '@material-ui/icons/Save';
import Icon from '@material-ui/core/Icon';
 import CodeExample from "../../partials/content/CodeExample";
import setDisplay from "../../partials/content/CodeExample";
import EditSchedule from './EditSchedule'

 import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
 
import Autocomplete from '@material-ui/lab/Autocomplete';
import { ThreeDRotationSharp } from "@material-ui/icons";
import Products from "./Products";
import Drawer from '@material-ui/core/Drawer';


//import Moment from 'moment';
 const styles = {
  drawerPaper: {
    width: '100%',
  },
};


export default class Schedule extends React.Component {
 
  handleDateChange = (date) => {
    this.setState({selectedDate : date});
  };

  state = {
    schedules:[],
    pRights:[],
    hasMoreItems:false,
    page:1,
    isReset:false,
    isLoading:false,
    filterFields :{},
    fields:[],
    filter:false,
    selectedDate:null,
    open:false,
    notes:[],
    notesId:'',
    statusSettings:{},
    postObj:{},
	statusFilter:null,
	productsDrawerOpen:false,
  }

 constructor(props)
{
	super(props);


}



toggleProductsDrawer = (open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }

    this.setState({productsDrawerOpen:false})
  };

  handleOpenProductsDrawer(sch)
{
	this.setState({productsDrawerOpen:true,selectedDrawerItem:sch});
}

resetFilter()
{
	let postObj={};
  		//this.state.filter=false;
  		  		this.setState({isReset:false});
  		  		
  		  		this.setState({filter:false},function(){
					this.setState({filter:true})		
  		  		})
				
  		  		
  	 	this.state.fields[0].fields.map((field)=> {
  			
  			this.state[`Filter_${field.fieldName}`]=null;

 
  			})
}

	reserFilterText()
	{
		this.setState({filter:true})
	}

   handleReset(event)
  {
  		let postObj={};
  		//this.state.filter=false;
  		  		this.setState({isReset:true});
  		  		
  		  		this.setState({filter:false},function(){
					this.setState({filter:true})		
  		  		})
				
  		  		
  	 	this.state.fields[0].fields.map((field)=> {
  			
  			this.state[`Filter_${field.fieldName}`]=null;
			if(field.dataType==='autocomplete')
			{
				this.setState({[field.fieldName]:[],[`Filter_${field.fieldName}`]:''});
				
			}
 
  			})

  			this.setState({activePage:1})
  		  	 getSchedules(1,{})//.then(response => response.data)
			    .then((response) => {

			
  		  			 		
			        this.setState({ schedules: response.data });
			        this.setState({isLoading:false})
			      	if(parseInt(response.headers["x-total-records"])>this.state.schedules.length)
			      		this.setState({hasMoreItems:true})
			      	else
			      		this.setState({hasMoreItems:false})
			      	  		this.setState({isReset:false});

	     });	
  }

  async componentWillReceiveProps(nextProps)
{
  let postObj={};
      
    if(this.props.location.data!==null && this.props.location.data!==undefined)
    {
    console.log(":::::props from dashboard::::::",this.props.location.data);
    postObj=this.props.location.data;
	//console.log("statuskeu props from dashboard:::",this.props.location.data.statusKey);
	if(this.props.location.data.statusKey!==null && this.props.location.data.statusKey!==undefined)
	{
		this.setState({statusFilter:this.props.location.data.statusKey});
	}
	if(this.props.location.data.accountId===null)
	{
		delete postObj.accountId;
		postObj = postObj;
	}
   }

   if(this.props.location.notification!==null && this.props.location.notification!==undefined)
    {
    //console.log(":::::props from header notification::::::",this.props.location.notification);
    let notification = this.props.location.notification.noti;
    //postObj=this.props.location.data;
    let notiObj = {
      isActive:false,
      isDeleted:true
    }
    updateNoti(notification.id,notiObj)
    .then((response)=>
    {
      //console.log(response);
    });
   }


     getSchedules(1,postObj)//.then(response => response.data)
    .then((response) => {
      this.setState({isLoading:false})
      this.setState({ schedules: response.data,postObj:postObj})
      this.setState({totalCount:response.headers["x-total-records"]});
      if(parseInt(response.headers["x-total-records"])>response.data.length)
        this.setState({hasMoreItems:true,isLoading:false})
      //console.log(this.state.users)
     })
}

  loadMore(){

  	let postObj={};
	  	//console.log(this.state.fields[0].fields);
	  	this.state.fields[0].fields.map((field)=> {
	  			
	  			if(this.state[`Filter_${field.fieldName}`]!=undefined && this.state[`Filter_${field.fieldName}`]!='')
	  			{
	  				 if(field.dataType==="lookup")
	  				 	postObj[field.lookUp.lookupKey]=this.state[`Filter_${field.fieldName}`];
					 else if(field.dataType==="autocomplete")
					 	postObj[field.lookUp.lookupKey]=this.state[`Filter_${field.fieldName}`];
	  				 else if (field.dataType==="date")
	  				 {
	  				 	//alert(field.fieldName+' : '+this.state[`Filter_${field.fieldName}`]);
	  				 	let varSelectedDate=this.state[`Filter_${field.fieldName}`]
	  				 	let formattedDate=format(varSelectedDate, 'yyyy-MM-dd')
	  				 	//const formattedDate = varSelectedDate.getFullYear()+'-'+(varSelectedDate.getMonth()+1)+'-'
	  				 	//+varSelectedDate.getDate();
	  				 	//alert(formattedDate);
	  				 	postObj[field.fieldName]=formattedDate;
	  				 }
	  				 else
	  				 {
	  				 	
	  				 	postObj[field.fieldName]=this.state[`Filter_${field.fieldName}`];
	  				 }
	  			}

	  			})
	if(this.state.statusFilter!==null)
	{
		postObj['statusKey'] = this.state.statusFilter;
	}

  	this.setState({isLoading:true})
    
  		this.setState({page:this.state.page+1},()=>
  	{
     getSchedules(this.state.page,postObj)//.then(response => response.data)
  	
    .then((response) => 
    {
      this.setState({ schedules:this.state.schedules.concat(response.data) }
      ,()=>{
      	this.setState({isLoading:false})
      	if(parseInt(response.headers["x-total-records"])>this.state.schedules.length)
      	this.setState({hasMoreItems:true})
      	else
      		this.setState({hasMoreItems:false})
      	

      });
     })
	});


   
  }

  viewComments=(schedule)=>
  {

  		

  		getNotes(schedule.pEntity[0].id).then((response) => {
  				this.setState({notes:response.data,notesId:schedule.id})
  				
		});


  }
  
  componentDidMount()
  {
 
  	//get status

  	getStatus().then(response => response.data)
    .then((data) => {
      this.setState({ mStatus: data })
     // console.log(data);
     });

    //getSettings("statusmaster").then(response => response.data)
    //.then((data) => {
    //  this.setState({ statusSettings: data })
    //  console.log(data);
    // });

    getAccounts().then(response => response.data)
      .then((data) => {
        this.setState({ mAccounts: data })
       // console.log(data);
       });


  	this.setState({hasMoreItems:false,isLoading:true});
  	getScreenFields('schedule')
  	.then((fieldResponse) => {
  		this.setState({fields:fieldResponse.data});

  		//console.log("fieldResponse",fieldResponse.data)
  		
  		let filterLength=fieldResponse.data[0].fields
  			.filter((fieldFilter) => fieldFilter.dataType==='lookup' || fieldFilter.dataType==='autocomplete').length;
  		//alert('loop length : '+filterLength );

  		let loopCounter =0;
  		fieldResponse.data[0].fields
  			.filter((fieldFilter) => fieldFilter.dataType==='lookup' || fieldFilter.dataType==='autocomplete')
  			.map((fieldMap)=>
  					{
  				//		alert(fieldMap.lookUp.lookupName);

  						// if(fieldMap.lookUp.lookupName==="pEntity")
  						// 	{

  						// 		getPatientRights(1,{})
  						// 		.then((filterResponse)=>
								// {
								// 	//console.log('Master :',fieldMap.fieldName);
								// 	//alert(fieldMap.fieldName);
								// 	this.setState({[fieldMap.fieldName]:filterResponse.data});
								// 	loopCounter++;
								// 	if(loopCounter===filterLength)
								// 		this.setState({filter:true});


								// })

  						// 	}
  						// 	else
						
							if(fieldMap.dataType.includes('autocomplete'))
							{
								console.log("datata",fieldMap.dataType);
								this.setState({[fieldMap.fieldName]:[]});
								loopCounter++;
								if(loopCounter===filterLength)
									this.setState({filter:true});

							}
							else if(fieldMap.dataType.includes('lookup'))
							{
								console.log("datata",fieldMap.dataType);
								getMaster(fieldMap.lookUp.lookupName)
								.then((filterResponse)=>
									{
										//console.log('Master :',fieldMap.fieldName);
										//alert(fieldMap.fieldName);
										this.setState({[fieldMap.fieldName]:filterResponse.data});
										loopCounter++;
										if(loopCounter===filterLength)
											this.setState({filter:true});


									})
							}
							
						}
  					
  				)
    });

    let postObj={};
			
  	if(this.props.location.data!==null && this.props.location.data!==undefined)
  	{
		console.log(":::::props from dashboard::::::",this.props.location.data);
		postObj=this.props.location.data;
		if(this.props.location.data.statusKey!==null && this.props.location.data.statusKey!==undefined)
		{
			this.setState({statusFilter:this.props.location.data.statusKey});
		}
		if(this.props.location.data.accountId===null)
		{
			delete postObj.accountId;
			postObj = postObj;
		}
	}

  if(this.props.location.notification!==null && this.props.location.notification!==undefined)
    {
    console.log(":::::props from header notification::::::",this.props.location.notification);
    let notification = this.props.location.notification.noti;
    //postObj=this.props.location.data;
    let notiObj = {
      isActive:false,
      isDeleted:true
    }
    updateNoti(notification.id,notiObj)
    .then((response)=>
    {
      console.log(response);
    });
   }


     getSchedules(1,postObj)//.then(response => response.data)
    .then((response) => {
    	this.setState({isLoading:false})
      this.setState({ schedules: response.data,postObj:postObj})
      this.setState({totalCount:response.headers["x-total-records"]});
      if(parseInt(response.headers["x-total-records"])>response.data.length)
      	this.setState({hasMoreItems:true,isLoading:false})
      //console.log(this.state.users)
     })


  }
  completeSchedule(sch)
  {
  	 sch.status="green";
     sch.percentage = 100;
      
      completeTask(sch)//.then(response => response.data)
      .then((response) => {
        //this.handleFilter(null);
        this.setState({schedules: this.state.schedules.map(el => (el.id === sch.id ? {...el, percentage:sch.percentage} : el))})	

      })
      .catch(() => {
                    
                    


                  });
  }

  updateSchedule(sch)
  {
  	 //sch.status="green";
     //sch.percentage = 100;
     sch.notes = this.state.notes;
     sch.status = this.state.tStatus;

     if(this.state.tStatus=="green")
     {
        sch.percentage = 100;
     }
     else if(this.state.tStatus=="#bd10e0")
     {
        sch.percentage = 0;
     }

      completeTask(sch)//.then(response => response.data)
      .then((response) => {
        //this.handleFilter(null);
        this.setState({schedules: this.state.schedules.map(el => (el.id === sch.id ? {...el, percentage:sch.percentage} : el))})	
        this.setState({open:false});
      })
      .catch(() => {
                    
                    


                  });
  }


handleCloseNew=async()=>
  {
  	//console.log("close new");
	this.dataload();
    
  }

  dataload = async() =>{
	
    let schedule =  this.state.schedule;
	let postObj = {scheduleKey:schedule.scheduleId};
  	//if(this.props.location.data!=null)
  	//{
	//	console.log(":::::props from dashboard::::::",this.props.location.data);
	//	postObj=this.props.location.data;
	//}


    await getSchedules(1,postObj)//.then(response => response.data)
    .then((response) => {
    	//console.log("notes::",response.data.length);
    	if(response.data.length>0)
    	{
			let s  = response.data[0];
	    	//response.data.map((s) => {
	    		//console.log("notes::+",s),
			  //console.log("update::::",s.procedureTypeKey,s.statusKey);
	    		//schedule.status = s.status,
	    		//schedule.notesCount= s.notesCount,
	    		//schedule.notes = s.notes,
	    		//schedule.scheduleType = s.scheduleType,
	    		//schedule.percentage = s.percentage,
          		//schedule.startDate = s.startDate,
          		//schedule.locationKey = s.locationKey,
				//schedule.procedureTypeKey = s.procedureTypeKey,
				//schedule.statusKey =  s.statusKey,
				let allRecords = this.state.schedules;
				let index = allRecords.findIndex(el => el.id == s.id);

				
				allRecords[index] = s;
				//console.log("ipdate data::::::",index, allRecords[index]);
				this.setState({schedules:allRecords});
				//this.setState({schedules: this.state.schedules.map(el => (el.id === s.id ? {...el, s} : el))})	
		
    	}
    	else
    	{
    		console.log("notes::-");
    		schedule.status = 'green';
    		schedule.percentage =100;
    		this.setState({schedules: this.state.schedules.map(el => (el.id === schedule.id ? {...el, schedule} : el))})	
    	}
    	
     })
	 this.setState({open:false});
  }


   handleClose = () =>
  {
    this.setState({open:false});
    let postObj={};
			
  	//if(this.props.location.data!=null)
  	//{
	//	console.log(":::::props from dashboard::::::",this.props.location.data);
	//	postObj=this.props.location.data;
	//}


     getSchedules(1,postObj)//.then(response => response.data)
    .then((response) => {
    	this.setState({isLoading:false})
      this.setState({ schedules: response.data})
      this.setState({totalCount:response.headers["x-total-records"]});
      if(parseInt(response.headers["x-total-records"])>response.data.length)
      	this.setState({hasMoreItems:true,isLoading:false})
      //console.log(this.state.users)
     })
  }

filterByStatus= (statusId) => {

  let postObj={};
			
  	this.resetFilter();
    console.log("filterby status:::::",statusId);
    if(statusId !=null && statusId!="")
    {
		postObj={
			statusKey: statusId
		};

		this.setState({statusFilter: statusId});
	}

	getSchedules(1,postObj)//.then(response => response.data)
    .then((response) => {
    	this.setState({isLoading:false})
      this.setState({ schedules: response.data,postObj:postObj})
      this.setState({totalCount:response.headers["x-total-records"]});
      if(parseInt(response.headers["x-total-records"])>response.data.length)
      	this.setState({hasMoreItems:true,isLoading:false})
      //console.log(this.state.users)
     });
}

  undoSchedule(sch)
  {
  	 sch.status="#bd10e0";
     sch.percentage = 0;
      
      completeTask(sch).then(response => response.data)
      .then((data) => {
        
        this.handleFilter(null);

      })
      .catch(() => {
                    
                    


                  });
  }

    handleFilter(event)
	{
	  	let postObj={};
	  		  	this.setState({isLoading:true});

	  	console.log(this.state.fields[0].fields);
	  	this.state.fields[0].fields.map((field)=> {
	  			
	  			if(this.state[`Filter_${field.fieldName}`]!=undefined && this.state[`Filter_${field.fieldName}`]!='' && field.isDummy ===false)
	  			{
	  				 if(field.dataType==="lookup")
	  				 	postObj[field.lookUp.lookupKey]=this.state[`Filter_${field.fieldName}`];
					 else  if(field.dataType==="autocomplete")
					 	postObj[field.lookUp.lookupKey]=this.state[`Filter_${field.fieldName}`];
	  				 else if (field.dataType==="date")
	  				 {
	  				 	//alert(field.fieldName+' : '+this.state[`Filter_${field.fieldName}`]);
	  				 	let varSelectedDate=this.state[`Filter_${field.fieldName}`]
	  				 	let formattedDate=format(varSelectedDate, 'yyyy-MM-dd')
	  				 	//const formattedDate = varSelectedDate.getFullYear()+'-'+(varSelectedDate.getMonth()+1)+'-'
	  				 	//+varSelectedDate.getDate();
	  				 	//alert(formattedDate);
	  				 	postObj[field.fieldName]=formattedDate;
	  				 }
	  				 else
	  				 {
	  				 	
	  				 	postObj[field.fieldName]=this.state[`Filter_${field.fieldName}`];
	  				 }
	  			}

	  			})
	  			this.setState({activePage:1})
	  		   
	  		    getSchedules(1,postObj)
					    .then((response) => {
					      this.setState({ schedules: response.data,page:1 , postObj:postObj})
					      this.setState({totalCount:response.headers["x-total-records"]});
					      if(parseInt(response.headers["x-total-records"])>response.data.length)
					      	this.setState({hasMoreItems:true})
					      else
					      	this.setState({hasMoreItems:false})
				this.setState({isLoading:false});					     })
	}

	autocompleteOnChange=(event,newValue,fieldName,lookupKey) => {
		if(event!==null && newValue!==null)
		{
		  console.log("autocomplete change:::",event ,newValue,fieldName,lookupKey,newValue[lookupKey]);
		  this.setState({[fieldName]:newValue[lookupKey]});
		}
		
	  }
	
	  autocompleteOnInputChange=async (event,value,fieldName,lookupKey,lookupName) =>  {
		if(event!==null && value!==null && value.length>3)
		{
		  //console.log("autocomplete input change:::",event ,value,fieldName,lookupKey);
		  //this.setState({[fieldName]:newValue[lookupKey]});
		  var postObj = {
			nameLowerCase: value.toLowerCase()
			
		  };
		  let patientData=[];
		
			await getPatientRights(1,postObj)
			  .then((response) => {
				  response.data.map((p)=>(
					 patientData.push(p)
				  ))
				  this.setState({ [fieldName]:patientData});
		   });
		   /*await getMaster(lookupName)
			.then((filterResponse)=>
			{
				this.setState({[fieldName]:filterResponse.data});
			});*/
		}
		
	  }
	  

	 exportClick(event)
	{
	  	let postObj={};
	
	  	this.state.fields[0].fields.map((field)=> {
	  			
	  			if(this.state[`Filter_${field.fieldName}`]!=undefined && this.state[`Filter_${field.fieldName}`]!='' && field.isDummy===false)
	  			{
	  				 if(field.dataType==="lookup")
	  				 	postObj[field.lookUp.lookupKey]=this.state[`Filter_${field.fieldName}`];
					 else if(field.dataType==="autocomplete")
						 postObj[field.lookUp.lookupKey]=this.state[`Filter_${field.fieldName}`];
	  				 else if (field.dataType==="date")
	  				 {
	  				 	//alert(field.fieldName+' : '+this.state[`Filter_${field.fieldName}`]);
	  				 	let varSelectedDate=this.state[`Filter_${field.fieldName}`]
	  				 	let formattedDate=format(varSelectedDate, 'yyyy-MM-dd')
	  				 	//const formattedDate = varSelectedDate.getFullYear()+'-'+(varSelectedDate.getMonth()+1)+'-'
	  				 	//+varSelectedDate.getDate();
	  				 	//alert(formattedDate);
	  				 	postObj[field.fieldName]=formattedDate;
	  				 }
	  				 else
	  				 {
	  				 	
	  				 	postObj[field.fieldName]=this.state[`Filter_${field.fieldName}`];
	  				 }
	  			}

	  			}) 
	  		   
	  		    getSchedulesExport(postObj)
					    .then((response) => {
					      if(response.data!=""){
					    	var win = window.open(response.data, '_blank');
  							win.focus();}
  							else
  								alert('Error exporting records')
					    })
	}

  render() {
  	//console.log("schedule::::",this.state.schedule);
    return (
      <>

      {

      	<div className="row">

          <div className="col-md-12">
            <CodeExample jsCode="true" beforeCodeTitle="Search To Do" csv ="true" exportClick={this.exportClick.bind(this)}>
              <div className="kt-section" >
              <Grid container spacing={3}>
      		  {
      			this.state.filter &&
		    	
		    	this.state.fields.map((screen) => (
		    		screen.fields.map((field)=>{
						
							if(field.dataType==='String')
							
							return(
								<Grid item xs={12} sm={6}>
									 <TextField  name={field.fieldName} label={field.displayName}
									 onChange={e=>this.setState({[`Filter_${field.fieldName}`]:e.target.value})}
									 />
						    	</Grid>
						    )
						    else if(field.dataType==='lookup' )
						    	return(
						    		<Grid item xs={12} sm={6}>
									 {field.lookUp.filterFieldName !==undefined && field.lookUp.filterFieldName!==null &&
						    		 <TextField   style={{'width':'100%'}} name={field.lookUp.lookupKey}
									 select
									 label={field.displayName}
									 onChange={e=>this.setState({[`Filter_${field.fieldName}`]:e.target.value})}
									 >
									 {
										this.state[field.fieldName].filter(x=>x[field.lookUp.filterFieldName]===this.state[`Filter_${field.lookUp.filterFieldName}`]).map((filter) => {
											return(
											<MenuItem key={filter[field.lookUp.lookupId]} 
											
											value={filter[field.lookUp.lookupId]}>

											{

												field.lookUp.lookupDisplay.split(/\s*,\s*/)
												.map((keyVal) => {
															return(<>{filter[keyVal]} </>);
													}
												)
											}</MenuItem>)
										})
									
									}
									</TextField>
									}
									{field.lookUp.filterFieldName ===undefined || field.lookUp.filterFieldName===null &&
						    		 <TextField   style={{'width':'100%'}} name={field.lookUp.lookupKey}
									 select
									 label={field.displayName}
									 onChange={e=>this.setState({[`Filter_${field.fieldName}`]:e.target.value})}
									 >
									 {
										this.state[field.fieldName].map((filter) => {
											return(
											<MenuItem key={filter[field.lookUp.lookupId]} 
											
											value={filter[field.lookUp.lookupId]}>

											{

												field.lookUp.lookupDisplay.split(/\s*,\s*/)
												.map((keyVal) => {
															return(<>{filter[keyVal]} </>);
													}
												)
											}</MenuItem>)
										})
									
									}
									</TextField>
									}
									</Grid>
						    )
							else if(field.dataType==='autocomplete')
						    	return(
						    		 <Grid item xs={12} sm={6}>
										 <Autocomplete
											id={field.lookUp.lookupKey}
											name={field.lookUp.lookupKey}
											value={this.state[`Filter_${field.fieldName}`]}
											options={this.state[field.fieldName]}
											autoComplete={true}
											clearOnBlur={true}
											getOptionLabel={(option) => option[field.lookUp.lookupDisplay]}
											onChange={(event,newValue)=>{this.autocompleteOnChange(event,newValue,`Filter_${field.fieldName}`,field.lookUp.lookupId);}}
											onInputChange={(event,value)=>{this.autocompleteOnInputChange(event,value,field.fieldName,field.lookUp.lookupId,field.lookUp.lookupName);}}						
											renderInput={(params) => <TextField {...params} label={field.displayName}/>}
										/>
						    		 </Grid>
						    )
						    else	 if(field.dataType==='date' )
							return(
								<Grid item xs={12} sm={6}>
									<MuiPickersUtilsProvider  utils={DateFnsUtils}>
		      
										        <KeyboardDatePicker
										          fullWidth
										          id="date"
										          label={field.displayName}
										          name = {field.fieldName}
										          format="MM/dd/yyyy"
										          value={this.state[`Filter_${field.fieldName}`]!=null ? this.state[`Filter_${field.fieldName}`] : null}
										          onChange={date =>this.setState({[`Filter_${field.fieldName}`]:date,selectedDate:date})}
										          KeyboardButtonProps={{
										            'aria-label': 'change date',
										          }}
										        />
										      
								    </MuiPickersUtilsProvider>
								
								</Grid>
															    
						    )
						   
						
		    			}) //{/* map  inner loop close*/}
		    		)) //{/* map loop close*/}
			}
			</Grid>
	    	</div>
		    	
		    	<div>
		    	<Button
				variant="outlined"
				color="primary"
				onClick={this.handleFilter.bind(this)}
				endIcon={<Icon>search</Icon>}
				style={{'padding':'10px','margin':'10px'}}
				>
				{
					this.state.isLoading==true&&<><Bounce /></>
				}
				{
					this.state.isLoading==false&&<>Apply Filter</>
				}
				</Button>
				
				<Button
				variant="outlined"
				color="primary"
				onClick={this.handleReset.bind(this)}
				endIcon={<Icon>backspace</Icon>}
				style={{'padding':'10px','margin':'10px'}}
				>
				{
					this.state.isReset==true&&<><Bounce /></>
				}
				{
					this.state.isReset==false&&<>Reset Filter</>
				}
				</Button>
 				</div>

            </CodeExample>
          	</div>
            </div>
		    }
		    <div className="kt-portlet">
				<div className="kt-portlet__body">
        			<div className="row">
		                {this.state.mStatus!=null && this.state.mStatus.map((status)=>(
		                  <div className="btn-toolbar kt-margin-l-20">
		                      <div className="dropdown" id="kt_subheader_group_actions_status_change">
		                      <button onClick={()=>this.filterByStatus(status.statusKey)} className="btn btn-success btn-elevate btn-pill btn-sm" style={{background: status.statusId, borderColor:status.statusId}}>
		                        {status.statusName}
		                      </button></div>
		                  </div>
		                  ))}
		                  <div className="btn-toolbar kt-margin-l-20">
		                      <div className="dropdown" id="kt_subheader_group_actions_status_change">
		                      <button onClick={()=>this.filterByStatus(null)} className="btn btn-success btn-pill btn-sm" style={{background:'#2c3e50',borderColor:'#2c3e50'}} >
		                        Show All
		                      </button></div>
		                  </div>
		            </div>
		        </div>
            </div>
		{/*
			this.state.isLoading===false && this.state.schedules.length===0 &&
			<div style={{"display":"flex","align-items":"center","justify-content": "center"}}>
				<Icon fontSize="large">search</Icon>
				<h2>No matching results found</h2>
			</div>
			
		*/}
      	{	


      		this.state.schedules.map((sch)=> (
      		
      			<>
      			{sch.pEntity!==null && sch.pEntity !== undefined && sch.pEntity.map((pentity)=> (
      
       
			<div className="kt-portlet">

				<div className="kt-portlet__body">
					<div className="kt-widget kt-widget--user-profile-3">
						<div className="kt-widget__top">
												<div className="kt-widget__media kt-hidden-">
													<img src="media/users/default.jpg" alt="user"/>
												</div>
												<div className="kt-widget__pic kt-widget__pic--danger kt-font-danger kt-font-boldest kt-font-light kt-hidden">
													JM
												</div>
												<div className="kt-widget__content">
													<div className="kt-widget__head">
														<a href='#' className="kt-widget__username" >
															 <Link
                    to={{pathname:"/viewpatient", search:"?id="+pentity.id+"&key="+pentity.pEntityId, data: pentity,fromPath: "/schedule", postObj: this.state.postObj, page: this.state.page}} target="_blank"
                    >
                  {pentity.firstName} {pentity.lastName} {' '}
                </Link>
															
															{/* sch.status == "green" && <i className="flaticon2-correct kt-font-success"></i>*/}
															{
															this.state.mStatus!=null &&
															(
															this.state.mStatus.filter(sts=> sts.statusKey==sch.statusKey).map((fsts)=>(
																<Tooltip title={fsts.statusName}>
																<button type="button" className="btn btn-danger btn-elevate btn-circle btn-icon" style={{background:fsts.statusId,borderColor:fsts.statusId, 'height':'10px', 'width':'10px'}}></button>
																</Tooltip>
															))
															)
															
														}

														<Tooltip title="Update To Do"><a href='#' onClick={()=>this.setState({open:true,schedule:sch, tStatus: sch.status})} ><IconButton>
															<EditIcon style={{ color: '#5578eb',fontSize: 18
														}}/>  
														</IconButton>
														</a> 
														</Tooltip>

														</a>
														<div className="kt-widget__action">

															{ sch.procedureTypeKey==="PTE00001" && sch.statusKey==="STA00008" && 
																<Tooltip title="Add Inventory">
																	<a href='#' onClick={()=>this.handleOpenProductsDrawer(sch)} >
																															<IconButton>
																																<DescriptionIcon style={{ color: '#5578eb',fontSize: 24
																																}}/>  
																															</IconButton></a> 
																																										
																</Tooltip>

																	}
															{ sch.status != "green" && sch.isTaskSequence==true && 
															 <Link className="btn btn-brand btn-sm btn-upper"
                    to={{pathname:"/createschedule", data: sch}}
                    >
                  {sch.scheduleType}
                </Link>}
															
															&nbsp;
															 { sch.status != "green" && <button type="button" onClick={()=> this.completeSchedule(sch)} className="btn btn-brand btn-sm btn-upper">Mark Complete</button>}
															 { sch.status == "green" && <button type="button" onClick={()=> this.undoSchedule(sch)} className="btn btn-brand btn-sm btn-upper">Undo</button>}
														</div>
													</div>
													<div className="kt-widget__subhead">
														<Tooltip title="Task Type"><a href='#' ><i className="flaticon2-schedule"></i>{sch.scheduleType}</a></Tooltip>
														{/*<a href='www.smartch.com' ><i className="flaticon2-calendar-3"></i>{sch.startDate} </a>*/}
														{sch.locationName!=null && 
														<Tooltip title="Location"><a href='#'><i className="flaticon2-placeholder"></i>{sch.locationName}</a></Tooltip>}
														<Tooltip title="Referred By"><a href='#' ><i className="flaticon2-calendar-3"></i>
														
														{
															this.state.mAccounts!=null && pentity.referredAccountKey!==null &&
															(
															this.state.mAccounts.filter(acc=> acc.accountId==pentity.referredAccountKey).map((facc)=>(
																facc.accountName
															))
															)
															
														}
														{
															this.state.mAccounts!=null && pentity.referredAccountKey===null &&
															(
															this.state.mAccounts.filter(acc=> acc.accountId==pentity.accountKey).map((facc)=>(
																facc.accountName
															))
															)
															
														}
														
														</a></Tooltip>
														<Tooltip title="Task Due Date"><a href='#' ><i className="flaticon2-calendar-3"></i>{format(new Date(sch.startDate), 'MM/dd/yyyy')} </a></Tooltip>
													</div>
													<div className="kt-widget__info">
														<div className="kt-widget__desc">
															{sch.notes}
														</div>
														{/*<div className="kt-widget__progress">
															<div className="kt-widget__text">
																Progress
															</div>
															<div className="progress" style={{height: '5px',width: '100%'}}>
																<div className="progress-bar kt-bg-success" role="progressbar" style={{width: sch.percentage+'%'}} aria-valuenow="0" aria-valuemin="0" aria-valuemax="100"></div>
															</div>
															<div className="kt-widget__stats">
																{sch.percentage}%
															</div>
														</div>
                            */}
													</div>
												</div>
						</div>
					 
					</div>
					<div className="kt-widget__footer">
													<div className="kt-widget__wrapper">
														<div className="kt-widget__section">
															
															<div className="kt-widget__blog">
																<i className="flaticon2-talk"></i>
																<a className="kt-widget__value kt-font-brand" onClick={()=>this.viewComments(sch)}>{sch.notesCount} Notes(s)</a>
															</div>

														</div>

													</div>
													{this.state.notes!=null && this.state.notesId==sch.id &&
													<div className="kt-chat">
														<div className="kt-portlet__body">
															<div className="kt-scroll kt-scroll--pull" data-mobile-height="300">
															    {this.state.notes!=null && this.state.notes.map((notes)=>(
																<div className="kt-chat__messages">
																	<div className="kt-chat__message">
																		<div className="kt-chat__user">
																			<span className="kt-media kt-media--circle kt-media--sm">
																				<img src="media/users/default.jpg" alt="image"/>
																			</span>
																			<a href="#" className="kt-chat__username"></a>
																			<span className="kt-chat__datetime">{notes.createdByFirstName + ' ' + notes.createdByLastName} {format(new Date(notes.createdOn), 'MM/dd/yyyy hh:mm')}</span>
																		</div>
																		<div className="kt-chat__text kt-bg-light-success">
																			{notes.notes}
																		</div>
																	</div>
																	
																</div>
																))}
															</div>
														</div>
														
										
													</div>
													}
													
												</div>
				</div>
			</div>
			
		))}
		</>
		))}
	
		{this.state.schedule!=null &&
		<Dialog open={this.state.open} onClose={this.handleCloseNew} aria-labelledby="form-dialog-title" maxWidth="md" >
       
        <DialogTitle id="form-dialog-title">{this.state.schedule.pEntity[0].firstName + ' ' +this.state.schedule.pEntity[0].lastName} - {this.state.schedule.scheduleType}</DialogTitle>
        <DialogContent>
          <EditSchedule schedule={this.state.schedule}  />
        </DialogContent>
      

        <DialogActions>
          <Button onClick={this.handleCloseNew} color="primary">
            Close
          </Button>
        
         
         
        </DialogActions>
         
      </Dialog>		
      }			
					
       
		{/*</InfiniteScroll>*/}
		{
			this.state.hasMoreItems &&
			<div style={{display:'flex', alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column'}}>

        <Button
				variant="outlined"
				color="primary"
				onClick={this.loadMore.bind(this)}
				
				style={{'padding':'10px','margin':'10px'}}
				>
				{
					this.state.isLoading==true&&<><Bounce /></>
				}
				{
					this.state.isLoading==false&&<><SearchIcon style={{ color: '#5867dd',fontSize: 25}}/>  Load More</>
				}
				</Button>

			
		</div>
		}

		{/**products selection drawer */}
				{this.state.selectedDrawerItem!=null  &&
				<Drawer  style ={{width:'100%'}}  anchor={'right'} open={this.state.productsDrawerOpen} onClose={this.toggleProductsDrawer} >
					<Products onUpdate={()=>this.updateItem(this.state.selectedDrawerItem)} onClose={()=>this.setState({productsDrawerOpen:false})} schedule={this.state.selectedDrawerItem} />
				</Drawer>
				}
      </>
    );
  }
}
